var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIphonecolor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 313,
    viewBox: "0 0 375 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_129",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 313
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375 0H156.283C70.0009 0 0.0558167 69.9451 0.0558167 156.227V312.453H375V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 200.361H0.0558167V203.876C0.0558167 202.7 0.0371094 201.528 0 200.361Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.608 -3.51489L448.11 315.188L261.736 315.188L385.975 -3.51489L490.608 -3.51489Z",
    fill: "url(#paint0_linear_20_129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.009 314.406L326.57 49.9324L226.514 25.0638L114.984 -1.56226L76.8539 -1.56226L98.6738 45.8007L7.86777 314.354L223.009 314.406Z",
    fill: "url(#paint1_linear_20_129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.009 314.406L326.57 49.9324L226.514 25.0638L114.984 -1.56226L76.8539 -1.56226L98.6738 45.8007L7.86777 314.354L223.009 314.406Z",
    fill: "url(#paint2_linear_20_129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.198 -7.42041L347.788 96.3938L448.427 315.188L222.348 315.188L240.547 269.542L114.492 -1.90762L390.198 -7.42041Z",
    fill: "#FFD100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4559 -18.917L222.68 314.406L-111.207 314.406L-291.306 -90.6113L68.4559 -18.917Z",
    fill: "#E20613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.492 -1.66292L114.572 -1.95264L349.613 -1.95264L240.45 269.882L114.492 -1.66292Z",
    fill: "url(#paint3_linear_20_129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.427 315.188H261.736L347.774 96.4702L448.427 315.188Z",
    fill: "url(#paint4_linear_20_129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.68 314.407H28.1774L110.157 70.6929L222.68 314.407Z",
    fill: "url(#paint5_linear_20_129)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_129",
    x1: 396.782,
    y1: 315.188,
    x2: 396.782,
    y2: 57.6054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00B4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_129",
    x1: 167.299,
    y1: 314.406,
    x2: 167.299,
    y2: -2.44485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_129",
    x1: 167.299,
    y1: 314.406,
    x2: 167.299,
    y2: -2.44485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#118FB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20_129",
    x1: 220.57,
    y1: 269.101,
    x2: 220.57,
    y2: -1.95264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20_129",
    x1: 355.081,
    y1: 96.4702,
    x2: 355.081,
    y2: 315.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FAE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20_129",
    x1: 222.68,
    y1: 192.574,
    x2: 28.1774,
    y2: 192.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#164194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CA9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphonecolor);
export default __webpack_public_path__ + "static/media/iphonecolor.e5090d5df21ce683fa267cf6dd374ef1.svg";
export { ForwardRef as ReactComponent };